import React, { useState, useRef } from 'react';
import Login from './Login';
import LoginNew from './LoginNew';
import './Home.css'
function Home() {
   

    return (
        <div className="home">
            <div className=" background-div ">
                <div className="p-2 text-center">

                    <h1 style={{ fontSize: '40px' }} className=" mt-5 display-1 text-light text-opacity-50">HA CONTROL CENTER</h1>
            </div>
            <div className="d-flex flex-row mb-3 justify-content-center">
               
                <div className="p-2 mt-5">
                    <Login userType='user' />
                    </div>
                    {/*<div className="p-2 mt-5">*/}
                    {/*    <LoginNew userType='user' />*/}
                    {/*</div>*/}
                </div>
               

            </div>
        </div>

    )
}
export default Home;